import * as Html from "../util/Html.ts";
export {init}
Html.registerWidget('widget/list-sharing',{init:init})

function init(div){
   var 
    controller = div.attr("data-controller-name")||"controller",
    main = div.find('input[name="'+controller+'"]'),
    textSharedOn = div.find('.fw-shared-text-on'),
    textSharedOff = div.find('.fw-shared-text-off'),
    memberPicker = div.find('.fw-member-picker'),
    toAllcontroller = div.find('input[name="sharedToAll"]'),
    others = div.find('input[name="sharedMemberIds"]'),
    emptyInput = div.append('<input type="hidden" name="sharedMemberIds" value="$empty">').children().last();
  
  function setEmpty(){
    emptyInput.prop('disabled',others.filter(':checked').length!==0)
  }
  
  function init(){
    var open = (main.val()==='true');
    textSharedOn.toggle(open);
    textSharedOff.toggle(!open);
    memberPicker.toggle(open);
    setEmpty();
    return open;
  }
  init();
  main.on('change',function(){
    var open = init();
    if(open){
      toAllcontroller.val('true').trigger('ui-change');
      others.prop('checked',true).trigger('ui-change');
    }else{
      toAllcontroller.val('false').trigger('ui-change');
      others.prop('checked',false).trigger('ui-change');
    }
    setEmpty();
  })
  
  toAllcontroller.on('change',function(){
    var toAllChecked = toAllcontroller.val()==='true';
    others.prop('checked',toAllChecked).trigger('ui-change');
    
    setEmpty();
    
  });
  others.on('change',function(){
    var checked = $(this).prop('checked');
    if(!checked){
      toAllcontroller.val('false').trigger('ui-change');
    }
    setEmpty();
  });
        
}